import LabServiceCollection from "../LabServiceCollection";
import AnalyteResultStatusLogModel from "@/models/lab/AnalyteResultStatusLogModel";

export default class AnalyteResultStatusLogCollection extends LabServiceCollection {
  model() {
    return AnalyteResultStatusLogModel;
  }

  prepareFilter(CollectionFilter) {
    CollectionFilter.defaultSortAddDesc('created_at');
  }

}
